import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetAvailableSpaceQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) {}

  async run(): Promise<any> {
    let data = await this.dispatcher.dispatch('get_available_space', {})
    this.frontend.available_space_information = data
  }
}